import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { LoanProduct } from 'app/models/dto/loan-product.model';
import { LoanProductCategory } from 'app/models/dto/loan-product-category.model';

export interface SortSetting {
  bestInput: number;
  defaultInput: number;
  parameter: string;
  weight: number;
  worstInput: number;
}

export interface LastMatchTimestamp {
  timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class LoanProductService {

  constructor(private http: ApiHttpClient) { }

  get(borrowerId: number): Observable<LoanProduct[]> {
    return this.http.get<LoanProduct[]>(`${environment.API_URL}/matching/borrower/${borrowerId}/loan-product`);
  }

  getLoanProductById(borrowerId: number, loanProductId: number): Observable<LoanProduct> {
    return this.http.get<LoanProduct>(`${environment.API_URL}/matching/borrower/${borrowerId}/loan-product/${loanProductId}`);
  }

  getSortSettings(borrowerId): Observable<SortSetting[]> {
    return this.http.get<SortSetting[]>(`/matching/sort-settings/borrower/${borrowerId}`);
  }

  getLoanProductsByLenderId(lenderId: number): Observable<LoanProduct[]> {
    const query = encodeURIComponent(
      JSON.stringify({
        criteria: {
          'lenderId': lenderId
        }
      })
    );
    return this.http.get<LoanProduct[]>(`${environment.API_URL}/loan-product?query=${query}`);
  }

  getLoanProductCategories(): Observable<LoanProductCategory[]> {
    return this.http.get<LoanProductCategory[]>(`${environment.API_URL}/loan-product-category`);
  }

  getLoanProductLastMatchTimestamp(borrowerId): Observable<LastMatchTimestamp> {
    return this.http.get<LastMatchTimestamp>(`/matching/borrower/${borrowerId}/last-run`);
  }

  rerunLoanProductMatching(borrowerId): Observable<void> {
    return this.http.post<void>(`/matching/borrower/${borrowerId}/calculate`, {});
  }
}
